<template>
    <div id="container" class="shadow-sm">
        <h1><img :src="this.icon" v-if="this.icon != null" />{{ title }}</h1>
        <div id="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "OverviewBox",
    props: {
        title: String,
        icon: String
    }
}
</script>

<style scoped>
#container {
    display: flex;
    flex-flow: column;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    height: 100%;
}

#content {
    flex: 1 1 auto;
    overflow: scroll;
}

h1 {
    font-size: 32px;
    text-align: left;
}

h1 img {
    margin-right: 8px;
    width: 50px;
    vertical-align: middle;
}
</style>
